module.exports = __webpack_public_path__ + "static/media/mmth-intro-logo.57203f09.png";